$(document).ready(function() {
    // console.log("Ulm.js");
    $('#ulmMaps .ulmMapsTrigger').click(_ttgMaps.f.ulmMap.init);

});

_ttgMaps.f.ulmMap = {

    init: function(e, optionHash, $entry) {
        // console.log("Ulm.js: ulmMap.init(e)", e);
        if (e) { e.preventDefault(); }

        _ttgMaps.mapOptions.container = 'ulmMap';
        _ttgMaps.mapOptions.center = {
            lat: $('#ulm').find('.form-control[name="standort"]').data('lat'),
            lng: $('#ulm').find('.form-control[name="standort"]').data('lon')
        };
        _ttgMaps.mapOptions.zoom = 15;
        _ttgMaps.mapOptions.experience = 'oberoesterreich-meta';
        _ttgMaps.mapOptions.mkt = 'de';
        _ttgMaps.metaParams.experience = _ttgMaps.mapOptions.experience;
        _ttgMaps.metaParams.mkt = _ttgMaps.mapOptions.mkt;

        _ttgMaps.$ulmMap = $('#ulmMaps #ulmMap');
        _ttgMaps.$ulmMap.index = 0;

        _ttgMaps.f.loading(_ttgMaps.$ulmMap);
        $('#ulmMaps').addClass('showMap');

        if (Done.Maps.isSupported()) {

            ttgMaps[_ttgMaps.$ulmMap.index] = Done.Maps.newMap(_ttgMaps.mapOptions);

            ttgMaps[_ttgMaps.$ulmMap.index].on('load', function() {

                ttgMaps[_ttgMaps.$ulmMap.index].map.setPitch(_ttgMaps.mapOptions.pitch);
                _ttgMaps.f.ulmMap.addLocation(ttgMaps[_ttgMaps.$ulmMap.index]);
                _ttgMaps.f.ulmMap.addOptions();
                _ttgMaps.f.loading(_ttgMaps.$ulmMap, 'remove');

                _ttgMaps.$ulmMap
                    .on('mouseenter', '.ttgMaps_customPin', function() {
                        _ttgMaps.f.ulmMap.highlight({
                            mode: 'add',
                            $pinInMap: $(this)
                        });
                    })
                    .on('mouseleave', '.ttgMaps_customPin', function() {
                        _ttgMaps.f.ulmMap.highlight({
                            mode: 'remove',
                            $pinInMap: $(this)
                        });
                    });

                // Map Klick aus Liste
                if (optionHash) {
                    $('#ulmMapOptions .ulmMapOption[href="#' + optionHash + '"]').trigger('click');
                    console.log('$entry', $entry);
                    if ($entry.length > 0) {
                        $entry.find('.ulmMaps_listTrigger_entry').trigger('click');
                        trackEvent('Global', 'ULM-Map', 'Init Map + Entry (inkl. Kategorie)', 1);
                    } else {
                        trackEvent('Global', 'ULM-Map', 'Init Map + Kategorie', 1);
                    }
                } else {
                    $.each($('#ulm .lists .list.initShowMap'), function() {
                        $(this).find('.ulmMaps_listTrigger_list').trigger('click');
                    });
                    trackEvent('Global', 'ULM-Map', 'Init Map', 1);
                }

            });

        }

    },

    addLocation: function(map) {
        // console.log("Ulm.js: ulmMap.addLocation(map)", map);

        if (map.locationMarker) {
            map.locationMarker.remove();
        }
        map.locationMarker = map.addLocationMarker({
            lng: (_ttgMaps.mapOptions.center.lng) ? _ttgMaps.mapOptions.center.lng : _ttgMaps.mapOptions.center.lon,
            lat: _ttgMaps.mapOptions.center.lat,
            color: '#CC3333'
        });
    },

    addOptions: function() {
        // console.log("Ulm.js: ulmMap.addOptions()");

        let $ulmMapOptions = $('<div />').prop('id', 'ulmMapOptions');

        $.each($('#ulm').find('.lists .list'), function() {
            const $icon = $('<a class="ulmMapOption" href="#' + $(this).prop('id') + '" />').html($(this).find('h2 > span').clone());
            $icon
                .click(function(e) {
                    _ttgMaps.f.ulmMap.listEntriesInMap(e, $(this).prop('href').split('#')[1]);
                })
                .appendTo($ulmMapOptions);
        });
        $ulmMapOptions.appendTo(_ttgMaps.$ulmMap);

    },

    listEntriesInMap: function(e, optionHash) {

        e.preventDefault();
        let $option = $('#ulmMapOptions .ulmMapOption[href="#' + optionHash + '"]');

        if ($option.hasClass('active')) {

            $option.removeClass('active');
            $('#' + optionHash).find('.ulmMaps_listTrigger_list').removeClass('active');

            // Entferne Elemente
            $.each(_ttgMaps.$ulmMap.find('.ttgMaps_customPin'), function(i, marker) {
                if ($(marker).attr('listId') === $option.prop('href').split('#')[1]) {
                    $('#' + $(marker).attr('listId') + ' .activeInMap').removeClass('activeInMap');
                    $(marker).remove();
                }
            });

            if (_ttgMaps.$ulmMap.find('.ttgMaps_customPin').length > 0) {
                _ttgMaps.f.ulmMap.fitBounds();
            } else {
                ttgMaps[_ttgMaps.$ulmMap.index].flyTo({
                    center: _ttgMaps.mapOptions.center,
                    zoom: _ttgMaps.mapOptions.zoom
                });
            }

        } else {

            $option.addClass('active');
            $('#' + optionHash).find('.ulmMaps_listTrigger_list').addClass('active');

            // Füge Elemente hinzu
            _ttgMaps.f.ulmMap
                .drawList($option)
                .then(_ttgMaps.f.ulmMap.fitBounds());

        }

    },

    drawList: async function($option) {
        // console.log("Ulm.js: ulmMap.drawList()", $option);

        const $list = $('#' + $option.prop('href').split('#')[1]);
        $.each($list.find('.entries .entry'), function() {
            _ttgMaps.f.ulmMap.drawEntry($(this));
        });

    },

    reDrawLists: function() {
        // console.log("Ulm.js: ulmMap.reDrawLists()");

        $.each(_ttgMaps.$ulmMap.find('#ulmMapOptions a.active'), function() {

            const $option = $(this);
            _ttgMaps.f.ulmMap
                .drawList($option)
                .then(_ttgMaps.f.ulmMap.fitBounds());
            $('#' + $option.prop('href').split('#')[1] + ' .ulmMaps_listTrigger_list').addClass('active');

        });

    },

    drawEntry: function($entry) {
        // console.log("Ulm.js: ulmMap.drawEntry()", $entry);

        const pin = {
            listId: $entry.closest('.list').prop('id'),
            id: $entry.data('id'),
            title: $entry.find('h3').text(),
            latlng: [$entry.data('lat'), $entry.data('lng')],
            web: $entry.find('>a').prop('href')
        };
        pin.marker = ttgMaps[_ttgMaps.$ulmMap.index].addMarker({
            lat: pin.latlng[0],
            lng: pin.latlng[1],
            color: _ttgMaps.pinColors.default
        });

        $(pin.marker._element).attr({
            'lat': pin.latlng[0],
            'lng': pin.latlng[1],
            'listId': pin.listId,
            'pinId': pin.id
        });

        // Pin Symbol
        let $pinSymbol = $('<span />').addClass('ttgMaps_pinSymbol').html('<i class="fa-fw ' + $('#' + pin.listId).find('h2 > span').prop('class') + '"></i>');
        $(pin.marker._element)
            .addClass('ttgMaps_customPin')
            .prop('title', pin.title)
            .append($pinSymbol)
            .wrapInner('<a href="' + pin.web + '" />');

        if ($entry.hasClass('activeInMap')) {
            $(pin.marker._element).addClass('highlight');
        }

    },

    highlight: function(highlight) {

        let $pulse = $('<div class="pulse"></div>').html('<div class="animate" style="box-shadow: 0 0 1px 2px ' + highlight.$pinInMap.find('svg path').attr('fill') + '"></div>');

        switch (highlight.mode) {
            case 'add':
                highlight.$pinInMap.append($pulse);
                break;

            case 'remove':
                highlight.$pinInMap.find('.pulse').remove();
                break;
        }

    },

    fitBounds: function() {
        // console.log("Ulm.js: ulmMap.fitBounds()");
        let north = 0, south = 0, east = 0, west = 0;
        $.each(_ttgMaps.$ulmMap.find('.ttgMaps_customPin'), function(index, marker) {
            if (index === 0) {
                north = $(marker).attr('lat');
                south = $(marker).attr('lat');
                east = $(marker).attr('lng');
                west = $(marker).attr('lng');
            }
            if ($(marker).attr('lat') > north) {
                north = $(marker).attr('lat');
            }
            if ($(marker).attr('lat') < south) {
                south = $(marker).attr('lat');
            }
            if ($(marker).attr('lng') > east) {
                east = $(marker).attr('lng');
            }
            if ($(marker).attr('lng') < west) {
                west = $(marker).attr('lng');
            }
        });
        ttgMaps[_ttgMaps.$ulmMap.index].fitBounds([{ lat: south, lng: west }, { lat: north, lng: east }]);
    },

    addListBtn: function($list) {

        if ($('#ulmMaps').length > 0) {
            let $a = $('<a href="#" class="ulmMaps_listTrigger_list"><span class="i fa-solid fa-map-location-dot"></span><span class="showInMap">In Karte anzeigen</span></a>');
            $a.on('click', function(e) {
                _ttgMaps.f.ulmMap.showMap(e, 'list')
            });
            $list.find('.container').append($a);

            $list.on('click', '.ulmMaps_listTrigger_entry', function(e) {
                _ttgMaps.f.ulmMap.showMap(e, 'entry');
            });
        }

    },

    showMap: function(e, mode) {
        // console.log("Ulm.js: ulmMap.showMap(e, mode)", e, mode);

        let optionHash = $(e.currentTarget).closest('.list').prop('id');

        if ($('#ulmMapOptions').length > 0) {

            e.preventDefault();
            // _ttgMaps.f.ulmMap.listEntriesInMap(e, optionHash);

            if (mode === 'list') {

                _ttgMaps.f.ulmMap.listEntriesInMap(e, optionHash);

            } else if (mode === 'entry') {

                if ($(e.currentTarget).closest('.entry').hasClass('activeInMap')) {

                    $(e.currentTarget).closest('.entry').removeClass('activeInMap');
                    _ttgMaps.$ulmMap.find('.ttgMaps_customPin[pinid="' + $(e.currentTarget).closest('.entry').data('id') + '"]').removeClass('highlight');

                } else {

                    if (!$(e.currentTarget).closest('.list').find('.ulmMaps_listTrigger_list').hasClass('active')) {
                        _ttgMaps.f.ulmMap.listEntriesInMap(e, optionHash);
                    }

                    $(e.currentTarget).closest('.entry').addClass('activeInMap');
                    _ttgMaps.$ulmMap.find('.ttgMaps_customPin[pinid="' + $(e.currentTarget).closest('.entry').data('id') + '"]').addClass('highlight');

                }

            }

        } else {

            // console.log('Init map > trigger Option Click');
            _ttgMaps.f.ulmMap.init(e, optionHash, $(e.currentTarget).closest('.entry'));

        }

        _ttgMaps.$ulmMap.animatescroll({
            padding: 200
        });

    },

    resetMap: function() {
        // console.log("Ulm.js: ulmMap.resetMap()", $('#ulmMapOptions').length);

        if ($('#ulmMapOptions').length > 0) {

            // Gewählten Standort setzen
            _ttgMaps.mapOptions.center = {
                lat: $('#ulm').find('.form-control[name="standort"]').data('lat'),
                lng: $('#ulm').find('.form-control[name="standort"]').data('lon')
            };
            _ttgMaps.f.ulmMap.addLocation(ttgMaps[_ttgMaps.$ulmMap.index]);
            ttgMaps[_ttgMaps.$ulmMap.index].flyTo({
                center: _ttgMaps.mapOptions.center,
                zoom: _ttgMaps.mapOptions.zoom
            });

            // Vorhandene Pins in Map entfernen
            _ttgMaps.$ulmMap.find('.ttgMaps_customPin').remove();

        }

    }

};